import { PaymentMethod as StripePaymentMethod } from '@stripe/stripe-js';

type Props = {
  stripe: unknown;
  elements: unknown;
  processing: boolean;
  succeeded: boolean;
  defaultPaymentMethod: {
    us_bank_account: Pick<NonNullable<StripePaymentMethod['us_bank_account']>, 'last4'> | null;
  } | null;
  useDifferentPaymentMethod: boolean;
  isValidCCNumber: boolean;
  isValidExpiry: boolean;
  isValidCvc: boolean;
  name: string;
  needsEmail: boolean;
  emailError: string | null;
  onlyFreeProducts: boolean;
  isAchPayment: boolean;
  userIsCreator: boolean;
  payerName: string;
  hasUnverifiedPaymentMethods: boolean;
};

const isButtonEnabled = ({
  stripe,
  elements,
  processing,
  succeeded,
  defaultPaymentMethod,
  useDifferentPaymentMethod,
  isValidCCNumber,
  isValidExpiry,
  isValidCvc,
  name,
  needsEmail,
  emailError,
  onlyFreeProducts,
  isAchPayment,
  userIsCreator,
  payerName,
  hasUnverifiedPaymentMethods,
}: Props): boolean => {
  if (processing || succeeded) {
    return false;
  }

  if (userIsCreator) {
    return false;
  }

  if (needsEmail && emailError) {
    return false;
  }

  if (onlyFreeProducts) {
    return true;
  }

  if (isAchPayment) {
    if (hasUnverifiedPaymentMethods) {
      return false;
    }

    if (defaultPaymentMethod?.us_bank_account && !useDifferentPaymentMethod) {
      return true;
    }

    return Boolean(name);
  }

  if (defaultPaymentMethod && !useDifferentPaymentMethod) {
    return Boolean(stripe) && Boolean(elements);
  }

  return (
    Boolean(stripe)
    && Boolean(elements)
    && isValidCCNumber
    && isValidExpiry
    && isValidCvc
    && Boolean(name)
    && Boolean(payerName)
  );
};

export default isButtonEnabled;
